import { useAuth, ROLES } from '../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { Badge } from './ui/badge';

export default function PageHeader({ title, description, badge, action }) {
  const { user } = useAuth();
  const { workspaceId } = useParams();
  const isSuperAdmin = user?.role === ROLES.SUPER_ADMIN;

  return (
    <header className="bg-white border-b border-slate-200 px-8 py-4" data-testid="page-header">
      <div className="max-w-7xl mx-auto flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <div className="flex items-center gap-3 mb-1">
            <h1 
              className="text-2xl font-semibold text-slate-900" 
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="page-title"
            >
              {title}
            </h1>
            {badge && (
              <Badge variant="secondary" className="text-xs">
                {badge}
              </Badge>
            )}
          </div>
          {description && (
            <p className="text-sm text-slate-500">{description}</p>
          )}
        </div>
        
        <div className="flex items-center gap-4 flex-shrink-0">
          {/* Action buttons */}
          {action && <div>{action}</div>}
          
          {/* Context indicator */}
          <div className="text-right">
            <p className="text-xs text-slate-400 uppercase tracking-wider">
              {isSuperAdmin ? 'Admin Portal' : 'Workspace'}
            </p>
            <p className="text-sm font-medium text-slate-600">
              {isSuperAdmin ? 'Global' : workspaceId}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
